import { FC } from 'react'
import cn from 'classnames'
import { ListRow } from 'components/extend/List'
import { useIsMobile } from 'hooks/media'

import s from '../../OrderTable.module.less'

export const OrderTableColumnHead: FC = () => {
  const isMobile = useIsMobile()

  if (isMobile) {
    return null
  }

  return (
    <ListRow className={cn(s.item, s.item_first)} testId="order--table--column--head">
      <div className={s.column__status}>Статус</div>
      <div className={s.column__departureTime}>Погрузка</div>
      <div className={s.column__transportation}>Перевозка</div>
      <div className={s.column__barcode_cargo}>Трек-номер / груз</div>
      <div className={s.column__price}>Цена</div>
      <div></div> {/* eslint-disable-line */}
    </ListRow>
  )
}
